<template>
  <div class="task-list">
    <Section
      :text="t('tasks.name', 2)"
      :offset="12"
    >
      <div class="task-list__items">
        <template
          v-for="task in dataAsArray"
          :key="task.id"
        >
          <ListTaskItem
            :task="task"
            @click="checkRead(task)"
          />
        </template>
      </div>
    </Section>
    <WaimoLoader
      v-if="!listIsLoaded"
      class="task-list__lazy-loader-indicator"
    />
  </div>
</template>

<script setup lang="ts">
import { WaimoLoader } from '@finetic/waimo-ui'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import Section from '@/components/ui/list/ListSection.vue'
import ListTaskItem from '@/components/ui/list/ListTaskItem.vue'
import { useTaskStore } from '@/stores/tasks'
import type { TaskType } from '@/types/taskType'

const { t } = useI18n()

const taskStore = useTaskStore()
const { dataAsArray } = storeToRefs(taskStore)
const { listIsLoaded } = storeToRefs(useTaskStore())

const loadNextPage = async (clear = false) => {
  await taskStore.fetchNextPage(clear)
}

if (!dataAsArray.value.length) loadNextPage()

const checkRead = (task: TaskType) => {
  if (!task.read) {
    task.read = true
    taskStore.updateTask(task)
  }
}

defineExpose({
  loadNextPage,
})
</script>

<style scoped lang="scss">
.task-list {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  &__items {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }

  &__lazy-loader-indicator {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 4.8rem;
    background-color: var(--color-primary-20);
    border-radius: 0.8rem;
  }
}
</style>
